<div class="modal1Main">
  <div class="modalHeader">
    <span class="title">
      <div class="teammenu_icon" *ngIf="isMobile" [matMenuTriggerFor]="menu"><i class="zmdi zmdi-menu"></i></div> {{ popupTitle }}
    </span>
    <mat-menu class="addFundMobMenu matsidemenuaddfund" #menu="matMenu" >
      <button mat-menu-item (click)="changeTab(0)">Summary</button>
      <button mat-menu-item (click)="changeTab(1)">Add funds</button>
      <button mat-menu-item (click)="changeTab(2)" *ngIf="fundTabIndex == 0">Add A Card</button>
      <button mat-menu-item (click)="changeTab(3)" *ngIf="fundTabIndex == 0">Saved Cards</button>
      <button mat-menu-item (click)="changeTab(4)">Cash out</button>
      <button mat-menu-item (click)="changeTab(5)">Account History</button>
      <button mat-menu-item (click)="changeTab(6)">Tickets</button>
      <button mat-menu-item (click)="changeTab(7)" *ngIf="userData && userData.payment_verified != 'Y'">Verification</button>
    </mat-menu>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div id="content" class="addFundMain">
    <div id="main-content">
      <div class="pendingOrder" *ngIf= "pending_orders > 0">
        <span>{{order_message}}</span>
      </div>
      <mat-tab-group #leftTabs [selectedIndex]="tab" (selectedTabChange)="changeTabData($event.index)">
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-chart"></i>
            Summary
          </ng-template>
          <div class="addFundIn">
            <div class="addFundHeding">
              <h1>Account Summary</h1>
            </div>
            <div class="accountSummaryMain" *ngIf="userData">
              <ul>
                <li>
                  <span class="left">Cash Balance</span>
                  <span class="right">
                    {{currency_symbol+(userData.redeemable_balance | number: '1.2-2' | Price)+' '+site_currency}}
                  </span>
                </li>
                <li *ngIf="userData.bonus_amount && userData.bonus_amount > 0">
                  <span class="left">Bonus Balance</span>
                  <span class="right" >
                      {{currency_symbol+(userData.bonus_amount | number: '1.2-2' | Price)+' '+site_currency}}
                  </span>
                </li>
                <li class="red">
                  <span class="left">Available To Play</span>
                  <span class="right" *ngIf="userData.dollar_balance">
                      {{currency_symbol+(userData.dollar_balance | number: '1.2-2' | Price)+' '+site_currency}}
                  </span>
                </li>
              </ul>
              <div class="spe1"></div>
              <ul>
                <li>
                  <span class="left">In Play</span>
                  <span class="right" *ngIf="userData.inplay_dollar_balance">
                      {{currency_symbol+(userData.inplay_dollar_balance | number: '1.2-2' | Price)+' '+site_currency}}
                  </span>
                </li>
                <li *ngIf="winAmt">
                  <span class="left">Currently Winning</span>
                  <span class="right" *ngIf="userData.inplay_dollar_balance">
                      {{ currency_symbol+(winAmt | number:'1.2-2' | Price)+' '+site_currency }}
                  </span>
                </li>
                <li>
                  <a href="javascript:;" (click)="changeTab(6)">
                  <span class="left">Tickets</span>
                  <span class="right" >{{summaryData.tickets}}</span>
                </a>
                </li>
                
              </ul>
              <div class="text-right width100 ">
                <button mat-raised-button color="primary" class="popupFundBtn mT25" (click)="changeTab(1)">Add Funds</button>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-plus-circle-o"></i>
            Add funds
          </ng-template>
          <div class="addFundIn deposit-method w-100" [ngClass]="{'verifyAddFundIn':userData?.payment_verified == 'N' && currentUser?.verify_before_deposits}" *ngIf="methodCardtype ==''">
            <div class="goToVerify-container" *ngIf="userData?.payment_verified == 'N' && currentUser?.verify_before_deposits;  else depositBlock">
              <p>Please verify your profile to insure uninterrupted access to your Tsevo account and services</p>
              <button class="popupFundBtn goToVerify-btn" (click)="goToVerify()">Verify</button>
            </div>
            <ng-template #depositBlock>
              <div class="deposit-main w-100">
                <div class="deposit-header">
                  <span>Choose a deposit method</span>
                </div>
                <div class="deposit-container w-100" [ngClass]="{'container-mob': isMobile}" >
                  <div class="deposit-method-btn w-100" (click)="openMethodCard('paypal')">
                    <div>
                      <img [src]="darkMode ? awsUploadUrl+'paypal-dark-logo.png' : awsUploadUrl+'paypal-logo.png'" alt="">
                    </div>
                    <div>
                      <span>PayPal</span>
                    </div>
                  </div>
                  <div class="deposit-method-btn w-100" (click)="openMethodCard('card')">
                    <div class="deposit-card-opt">
                      <div>
                        <img [src]="awsUploadUrl+'mastercard-logo.png'" alt="">
                      </div>
                      <div>
                        <img [src]="awsUploadUrl+'visa-logo.png'" alt="">
                      </div>
                      <div class="card-type">
                        <img [src]="awsUploadUrl+'express_logo.png'" alt="">
                      </div>
                    </div>
                    <div>
                      <span>Credit or Debit Card</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="addFundIn" *ngIf="fundsData" #addFundFormElementTop>
            <div *ngIf="fundTabIndex == 0 && paymentDetail?.status == '' && methodCardtype =='card'" class="cards-container">
              <app-save-card-payment *ngIf="fundsData.paymentMethod.length > 0; else addCardTemplate" [saveCardReload]="fundsData.paymentMethod.length"></app-save-card-payment>
              <ng-template #addCardTemplate>
                <app-first-time-deposit (depositSuccess)="handleDepositSuccess($event)"></app-first-time-deposit>
              </ng-template>
              <br>
            </div>
            <a *ngIf="fundTabIndex == 0 && paymentDetail?.status == '' && methodCardtype =='card'" (click)="changeAddFundTab(1)" class="payment-mode-card">Try PayPal...</a>
            <div *ngIf="fundTabIndex == 1 && paymentDetail?.status == '' && methodCardtype =='paypal'">
              <div class="cardDetailForm">
                <flash-messages *ngIf="fundTabIndex == 1"></flash-messages>
                <div class="formControlMain">
                  <div class="disIb ">
                    <label class="cardDetailLabel">Charge Amount (USD) </label>
                    
                    <ng-container *ngIf="fundsData && fundsData.dataList">
                        <button type="button" mat-stroked-button [ngClass]="{'customChargeBtn': true, 'checked_amt':((item.money == paypalForm.selected_package) && (paypal_amt == ''))}" class="customChargeBtn" *ngFor="let item of fundsData.dataList" (click)="getPayPalAmount(item.money)">{{item.money | number }}</button>
                    </ng-container>
                    <mat-form-field class="form-control width100p">
                      <input matInput type="text" [(ngModel)]="paypal_amt"  (keypress)="keyPress($event)" (focusout)="onBlur($event)" (blur)="onBlur($event)">
                    </mat-form-field>
                  </div>
                </div>
                <div class="formControlMain" *ngIf="!fundsData.hidePromo">
                  <div class="disIb  width280p">
                    <label class="cardDetailLabel">Promo Code </label>
                    <mat-form-field class="form-control ">
                      <input matInput type="text" [(ngModel)]="paypalForm.promo_code">
                    </mat-form-field>
                    <span class="checkValue" *ngIf="promo_code_validation.icon" [ngStyle]="{'color': promo_code_validation.icon_color}" ><i  [class]="promo_code_validation.icon"></i></span>
                  </div>
                  <mat-error *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate!='yes'" style="left: 15px;">{{ promo_code_validation.message }}</mat-error>
                  <div *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate=='yes'" style="font-size:14px;position: absolute;color:var(--green-dark)">{{
                    promo_code_validation.message }}</div>
                  <button type="button" mat-raised-button color="" class="custom-btn check-pormoBtn" (click)="checkPromoCode('paypal')">Check</button>
                </div>
                <mat-error *ngIf="selfExclusion" class="errorMsg">
                  You are temporarily unable to deposit as you are still within your self exclusion time frame.
                </mat-error>
                <div class="text-left  width200px" [ngStyle]="{'display': (validPayPal && !selfExclusion) ? 'block':'none'}">
                  <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                </div>
              </div>
              <br/>
              <a (click)="changeAddFundTab(0)" class="payment-mode">PayPal not working? Try this...</a>
            </div>
            <div *ngIf="paymentDetail?.status != '' ">
              <div class="cardDetailForm">
                <div class="cashConfirm">
                  <i class="fas fa-circle-check"></i>
                  <div class="topTitle">
                    <i class="fas fa-check success" *ngIf="paymentDetail.status == 'completed' "></i>
                    <i class="fas fa-exclamation-triangle failed" *ngIf="paymentDetail.status == 'failed' "></i>
                    Deposit {{paymentDetail.status}}!</div>
                  <div class="cashMessage {{paymentDetail.class}}" [innerHTML]=paymentDetail.message></div>
                  <a href="https://drafters.com/lobby/all" class="mat-raised-button mat-primary">Go to Lobby!</a>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <!--*************************************Start Add A Card***************************************** -->
        <mat-tab *ngIf="fundTabIndex == 0">
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-card"></i>
            Add A Card
          </ng-template>
          <div class="add-a-card">
            <div class="addFundIn">
              <div class="addFundHeding">
                <h1>Add Card</h1>
              </div>
              <div class="cardDetailForm ">
                  <form [formGroup]="cardForm" (ngSubmit)="onCardSubmit()" class="add-card-form">
                    <div class="add-card-body">
                      <flash-messages *ngIf="currentTabIndex == 2"></flash-messages>
                      <div class="formControlMain">
                        <div>
                          <label class="cardDetailLabel">Name On Card</label>
                          <mat-form-field class="form-control centered-placeholder " floatLabel='never'>
                            <input matInput formControlName="name" placeholder="Full Name" maxlength="30">
                          </mat-form-field>
                          <mat-error *ngIf="cardSubmitted && !c.name.valid">
                            Name on card is required or invalid.
                          </mat-error>
                        </div>
                      </div>
                      <div class="formControlMain">
                        <div class="disIb w-100">
                          <label class="cardDetailLabel">Card Number </label>
                          <mat-form-field class="form-control " floatLabel='never'>
                            <input matInput formControlName="card_number" placeholder="XXXX-XXXX-XXXX-XXXX" ccNumber maxlength="20">
                          </mat-form-field>
                          <mat-error *ngIf="cardSubmitted && !c.card_number.valid">
                              Card Number is required or invalid.
                          </mat-error>
                        </div>
                      </div>
                      <div class="formControlMain card-details">
                        <div class="disIb expiry-date">
                          <label class="cardDetailLabel">Expiry Date</label>
                          <mat-form-field class="form-control " floatLabel='never'>
                            <input matInput formControlName="expiry" placeholder="MM/YY" type="tel" ccExp>
                          </mat-form-field>
                          <mat-error *ngIf="cardSubmitted && !c.expiry.valid">
                            Expiry Date is required.
                          </mat-error>
                        </div>

                        <div class="disIb Zip">
                          <label class="cardDetailLabel">Zip/Postal Code</label>
                          <mat-form-field class="form-control " floatLabel='never'>
                            <input matInput formControlName="zip_code" placeholder="Zip/Postal Code" maxlength="10">
                          </mat-form-field>
                          <mat-error *ngIf="cardSubmitted && c.zip_code.errors && c.zip_code.errors.required">
                            Zip/Postal Code is required.
                          </mat-error>
                          <mat-error *ngIf="cardSubmitted && c.zip_code.errors && (c.zip_code.errors.minlength || c.zip_code.errors.maxlength)">
                            Zip/Postal must be min 5 digit and max 10 digit.
                          </mat-error>
                        </div>
                    </div>
                    <div class="text-left ">
                      <button mat-raised-button type="submit" color="primary" class="popupFundBtn" [disabled]="isDisable">Add Method</button>
                    </div>
                     <div class="addCardImg">
                      <div>
                        <img [src]="awsUploadUrl+'mastercard_logo.png'" alt="">
                      </div>
                      <div>
                        <img [src]="awsUploadUrl+'visa_logo.png'" alt="">
                        </div>
                      <div>
                        <img [src]="awsUploadUrl+'express_logo.png'" alt="">
                      </div>
                    </div>
                    </div>
                  </form>
              </div>
            </div>
          </div>
        </mat-tab>

        <!--**************************************End Add A Card**************************************** -->
        <mat-tab *ngIf="fundTabIndex == 0">
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-card"></i>
            Saved Cards
          </ng-template>
          <div class="addFundIn">
            <div class="addFundHeding">
              <h1>Saved Cards</h1>
              <div class="addFundHedingRight float-right">
                <button mat-button (click)="deleteCardPopup()">Delete All</button>
              </div>
            </div>
            <div class="cardTable example-container mat-elevation-z8">
              <perfect-scrollbar class=" maxHei300" [config]="config" style="max-width: 100%;">

                <table mat-table [dataSource]="savedCardsData" class="mat-elevation-z8"> 
                  
                  <ng-container matColumnDef="cardimg">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"><!-- <img src="{{element.cardimg}}" alt="" class="cardImg"> --> </td>
                  </ng-container>


                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                  </ng-container>


                  <ng-container matColumnDef="lastfordigit">
                    <th mat-header-cell *matHeaderCellDef> Last 4 Digits </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastfordigit}} </td>
                  </ng-container>


                  <ng-container matColumnDef="expirydate">
                    <th mat-header-cell *matHeaderCellDef> Expiry Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.expirydate}} </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element; let i = index;"> <a href="javascript:;" class="deleteRecord" (click)="deleteCardPopup(element.id,i)"><i class="{{element.action}}"></i></a>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="check">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox class="example-margin" [checked]="AllChecked" (change)="cardCheck($event,'all', '','')"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index;">
                      <mat-checkbox class="example-margin" [checked]="element.check" (change)="cardCheck($event,'', i, element.id)"></mat-checkbox>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div *ngIf="savedCardsData.length == 0" class="text-center">No Payment Method Found</div>
              </perfect-scrollbar>
            </div>
          </div>
        </mat-tab>
        <!-- **********************************************Cash Out********************************************** -->
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-money-box"></i>
            Cash out
          </ng-template>
          <div class="addFundIn" *ngIf="userData">
            <mat-tab-group class="horizontal">
              <mat-tab label="Add Cash Out">
                <div class="addCashOutMain cardDetailForm" *ngIf="!cashOutConfirmation && !cashOutForfeitConfirmation">
                  <form [formGroup]="cashOutFrom" (ngSubmit)="onCashOutSubmit()">
                  <flash-messages *ngIf="currentTabIndex == 4"></flash-messages>

                  <div class="alert flash-message alert-danger text-center" *ngIf="cashOutErr">
                    <button aria-label="Close" class="close ng-star-inserted" data-dismiss="alert" type="button" (click)="cashOutErrHide()"><span aria-hidden="true">×</span></button>
                    <div>We will have to verify your age and location before Cash out process. <br/>Please <a href="javascript:;" (click)="changeTab(7)"><u>click here</u></a> to verify.</div>
                  </div>

                  <div class="addCashOutIn">
                    <label class="addCashOutLabel">Available Balance</label>
                    <div class="addCashOutRight ">
                      <label class="addCashOutLabel" *ngIf="userData.dollar_balance">{{currency_symbol+(userData.redeemable_balance | number:'1.2-2' | Price)+' '+site_currency}}</label>
                    </div>
                  </div>
                  <div class="addCashOutIn">
                      <label class="addCashOutLabel verTop">Cashout Method</label>
                      <div class="addCashOutRight">
                        <mat-radio-group formControlName="cashout_method" class="cashOutRadio">
                          <mat-radio-button *ngFor="let method of summaryData.cashoutMethod" [value]="method.key" [disabled]="!method.status">{{ method.value }}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                  </div>
                  <div class="addCashOutIn" *ngIf="d.cashout_method.value == 'paypal'">
                    <label class="addCashOutLabel">Paypal Email</label>
                    <div class="addCashOutRight ">
                      <mat-form-field class="form-control width230p"  >
                        <input matInput formControlName="request_paypal" type="text">
                      </mat-form-field>
                      <mat-error *ngIf="cashOutSubmitted && d.request_paypal.errors && d.request_paypal.errors.required">
                          Paypal Email is required.
                      </mat-error>
                      <mat-error *ngIf="cashOutSubmitted && d.request_paypal.errors && d.request_paypal.errors.email">
                          Please enter valid email.
                      </mat-error>
                    </div>
                  </div>
                  
                  <div *ngIf="d.cashout_method.value == 'wire_transfer'">
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Name (on bank account)</label>
                      <div class="addCashOutRight">
                        <mat-form-field class="form-control width230p">
                          <input matInput formControlName="cashout_holder_name" />
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_holder_name.errors && d.cashout_holder_name.errors.required">
                          Name is required.
                        </mat-error>
                      </div>  
                    </div>
                    
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Full Home Address</label>
                      <div class="addCashOutRight">
                        <mat-form-field class="form-control width230p pR0 textareaBox">
                          <textarea matInput formControlName="cashout_address"></textarea>
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_address.errors && d.cashout_address.errors.required">
                          Address is required.
                        </mat-error>
                      </div>
                    </div>
                    
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Bank Name</label>
                      <div class="addCashOutRight ">
                        <mat-form-field class="form-control width230p">
                          <input matInput formControlName="cashout_bank_name" />
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_bank_name.errors && d.cashout_bank_name.errors.required">
                          Bank name is required.
                        </mat-error>
                      </div>  
                    </div>
                    
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Full Bank Address</label>
                      <div class="addCashOutRight">
                        <mat-form-field class="form-control width230p pR0 textareaBox">
                          <textarea matInput formControlName="cashout_bank_address"></textarea>
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_bank_address.errors && d.cashout_bank_address.errors.required">
                          Bank Address is required.
                        </mat-error>
                      </div>
                    </div>
                    
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Account Number</label>
                      <div class="addCashOutRight ">
                        <mat-form-field class="form-control width230p">
                          <input matInput formControlName="cashout_account_number" />
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_account_number.errors && d.cashout_account_number.errors.required">
                          Account Number is required.
                        </mat-error>
                      </div>  
                    </div>
                    
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Bank SWIFT Code</label>
                      <div class="addCashOutRight ">
                        <mat-form-field class="form-control width230p">
                          <input matInput formControlName="cashout_swift_code" />
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.cashout_swift_code.errors && d.cashout_swift_code.errors.required">
                          Bank SWIFT Code is required.
                        </mat-error>
                      </div>  
                    </div>
                    <div class="addCashOutIn">
                      <label class="addCashOutLabel">Amount</label>
                      <div class="addCashOutRight ">
                        <mat-form-field class="form-control width230p pR0" >
                          <input matInput formControlName="request_amount" (keypress)="keyPress($event)">
                          <mat-icon matSuffix >USD</mat-icon>
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.required">
                            Amount is required.
                        </mat-error>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.pattern">
                            Please enter valid amount.
                        </mat-error>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.min">
                            Minimum amount must be ${{wireTransferCashoutLimit}}.
                        </mat-error>
                        <span class="text-right minAmount">Min: ${{wireTransferCashoutLimit}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="addCashOutIn" *ngIf="d.cashout_method.value == 'cheque_by_email'">
                    <label class="addCashOutLabel">Address</label>
                    <div class="addCashOutRight ">
                      <mat-form-field class="form-control width230p"  >
                        <textarea matInput formControlName="cashout_address"></textarea>
                      </mat-form-field>
                      <mat-error *ngIf="cashOutSubmitted && d.cashout_address.errors && d.cashout_address.errors.required">
                          Address is required.
                      </mat-error>
                    </div>
                  </div>
                  <div class="addCashOutIn" *ngIf="d.cashout_method.value != 'wire_transfer'">
                      <label class="addCashOutLabel">Amount</label>
                      <div class="addCashOutRight ">
                        <mat-form-field class="form-control width230p pR0" >
                          <input matInput formControlName="request_amount" (keypress)="keyPress($event)">
                          <mat-icon matSuffix >USD</mat-icon>
                        </mat-form-field>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.required">
                            Amount is required.
                        </mat-error>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.pattern">
                            Please enter valid amount.
                        </mat-error>
                        <mat-error *ngIf="cashOutSubmitted && d.request_amount.errors && d.request_amount.errors.min">
                            Minimum amount must be ${{d?.cashout_method?.value === 'paypal' ? paypalCashoutLimit : cadCashoutLimit}}.
                        </mat-error>
                        <span class="text-right minAmount">Min: ${{d?.cashout_method?.value === 'paypal' ? paypalCashoutLimit : cadCashoutLimit}}</span>
                      </div>
                  </div>
                  <div class="addCashOutIn"  *ngIf="userData.bonus_amount && userData.bonus_amount > 0">
                      <label class="addCashOutLabel">Bonus Rollover Progress</label>
                      <div class="addCashOutRight ">

                        <div class="progSummary">
                          <span class="progSummaryText left">{{currency_symbol+(userData.current_rollover_amount | number: '1.2-2' | Price)}}</span>
                          <span class="progSummaryMid">
                            <div class="progSummaryPro" [ngStyle]="{'width': userData.rollover_percentage}">
                              {{userData.rollover_percentage}}
                            </div>
                          </span>
                          <span class="progSummaryText right">{{currency_symbol+(userData.total_rollover | number: '1.2-2' | Price)}}</span>
                        </div>

                      </div>
                  </div>
                  <div class="emtTExt" *ngIf="d.cashout_method.value == 'email_money_transfer'">{{summaryData.emt_alert}}</div>
                  <div class="text-left width100 ">
                    <button mat-raised-button color="primary" class="popupFundBtn" [disabled]="disableCashOut">Submit</button>
                  </div>
                  </form>
                </div>
                <div class="cash_confirmation" *ngIf="cashOutConfirmation && !phoneNumerVerified && !isOpenOtpPopup">
                  <flash-messages *ngIf="currentTabIndex == 4"></flash-messages>
                  <h3>Cash Out confirmation</h3>
                  <div class="heading">
                      Cashout <span class="amount">${{ d.request_amount.value }}</span> by <span>"{{ cashoutMethodWord | titlecase }}"</span>
                  </div>
                  <div *ngIf="d.cashout_method.value == 'wire_transfer';else defaultBody">
                    <div class="accountSummaryMain" id="cashout-information">
                      <ul>
                        <li>
                          <span class="label">Name (on bank account):</span>
                          <span>{{ d?.cashout_holder_name?.value }}</span>
                        </li>
                        <li>
                          <span class="label">Full Address:</span>
                          <span>{{ d?.cashout_address?.value }}</span>
                        </li>
                        <li>
                          <span class="label">Bank Name:</span>
                          <span>{{ d?.cashout_bank_name?.value }}</span>
                        </li>
                        <li>
                          <span class="label">Full Bank Address:</span>
                          <span>{{ d?.cashout_bank_address?.value }}</span>
                        </li>
                        <li>
                          <span class="label">Account Number:</span>
                          <span>{{ d?.cashout_account_number?.value }}</span>
                        </li>
                        <li>
                          <span class="label">Bank SWIFT Code:</span>
                          <span>{{ d?.cashout_swift_code?.value }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="confirm_btn">
                        <button mat-raised-button type="button" color="primary" class="popupFundBtn" (click)="currentUser && currentUser['mfa_on_cashout'] ? openOtpPopup() : cashOutSubmit('confirm')">Confirm</button>
                        <button mat-raised-button type="button" color="danger" class="popupFundBtn cancleBtn" (click)="cashOutSubmit('back')">Edit</button>
                    </div>  
                  </div>
                  <ng-template #defaultBody>
                    <div class="detail" *ngIf="d.cashout_method.value == 'paypal'">
                      Paypal Email: {{ d?.request_paypal?.value }}
                      <span *ngIf="d.cashout_method.value == 'cheque_by_email'">Detail: <b>{{ d.cashout_address.value }}</b></span> 
                    </div>
                    <div class="detail" *ngIf="d.cashout_method.value == 'cheque_by_email'">
                        Detail: <b>{{ d.cashout_address.value }}</b> 
                    </div>
                    <div class="detail">
                        All Cashout requests need to be reviewed 
                        and may take up to 3 days to be processed.
                    </div>
                    <div class="confirm_btn">
                        <button mat-raised-button type="button" color="primary" class="popupFundBtn" (click)="currentUser && currentUser['mfa_on_cashout'] ? openOtpPopup() : cashOutSubmit('confirm')">Confirm</button>
                        <button mat-raised-button type="button" color="danger" class="popupFundBtn cancleBtn" (click)="cashOutSubmit('cancel')">Cancel</button>
                    </div>
                  </ng-template>
                </div>
                <div class="otp-verification" *ngIf="isOpenOtpPopup && !phoneNumerVerified">
                  <flash-messages *ngIf="currentTabIndex == 4 && isOpenOtpPopup"></flash-messages>
                  <h1 class="heading">SMS Verification</h1>
                  <p class="otp-verification-text">Enter the OTP sent to XXXXXX{{primaryNumberOtp||''}}</p>
                  <div class="otp-input">
                    <mat-form-field>
                      <input matInput type="text" [(ngModel)]="otpValue" maxlength="6" (ngModelChange)="validateOtp()">
                    </mat-form-field>
                    <button class="verify-otp-button" [disabled]="cashOutSubmitted || !isOtpVerified" (click)="submitVerify()">Verify</button>
                  </div>
                  <p class="resend-timer" *ngIf="countDown > 0">You can resend in <span> {{countDown}} seconds</span></p>
                  <button class="resend-button" (click)="openOtpPopup()" *ngIf="otpSent && countDown < 1">Re-Send Code</button>
                </div>
                <div class="otp-verification" *ngIf="phoneNumerVerified && !isOpenOtpPopup">
                  <flash-messages *ngIf="currentTabIndex == 4 && phoneNumerVerified"></flash-messages>
                  <h1 class="heading">SMS Verification</h1>
                  <p class="otp-verification-text">Enter Phone Number</p>
                  <div class="number otp-input">
                    <mat-form-field class="form-control " floatLabel='never'>
                        <label>{{countryCode}}</label>
                        <input matInput type="text" [formControl]="phoneNumberControl" maxlength="10" placeholder="Enter Phone Number"/>
                    </mat-form-field>
                    <button class="verify-otp-button" (click)="submitPhoneVerified()">Send OTP</button>
                  </div>
                  <mat-error *ngIf="phoneNumberControl.invalid && phoneNumberControl.touched">
                    {{ getErrorMessage() }}
                </mat-error>
                  <p class="resend-timer" *ngIf="countDown > 0">You can resend in <span> {{countDown}} seconds</span></p>
                  <button class="resend-button" (click)="openOtpPopup()" *ngIf="otpSent && countDown < 1">Re-Send Code</button>
                </div>
                <div class="cash_confirmation" *ngIf="cashOutForfeitConfirmation">
                  <h3>Warning</h3>
                  <div class="heading">You are submitting a withdrawal with bonus funds currently in your account. If you submit your withdrawal before using your bonus, bonus funds in your account will be forfeited.  To avoid losing your bonus funds, simply play <span class="amount">${{ (userData.total_rollover | number: '1.2-2' | Price) }}</span> worth of contest entries before submitting a withdrawal.  At that time, all bonus funds will be automatically be converted into withdrawable cash.
                  </div>
                  <div class="detail">
                    Are you sure you'd like to continue?
                  </div>
                  <div class="confirm_btn">
                      <button mat-raised-button type="button" color="primary" class="popupFundBtn" (click)="cashOutForfitSubmit('confirm')">Proceed</button>
                      <button mat-raised-button type="button" color="danger" class="popupFundBtn cancleBtn" (click)="cashOutForfitSubmit('cancel')">Cancel</button>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Pending Cash Out">
                <div class="cardTable example-container mat-elevation-z8">
                  <perfect-scrollbar class=" maxHei300" [config]="config" style="max-width: 100%;">
                    <table mat-table [dataSource]="pendingCashData" class="mat-elevation-z8">
                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date </th>
                        <td mat-cell *matCellDef="let element"> <span>{{element.date}}</span> </td>
                      </ng-container>
                      <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef>Amount </th>
                        <td mat-cell *matCellDef="let element">{{currency_symbol}} {{element.amount | number:'1.2-2' | Price}} </td>
                      </ng-container>
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action </th>
                        <td mat-cell *matCellDef="let element"><a href="javascript:;"  class="deleteRecord" (click)="cancelCashOut(element.id)"><i class="far fa-trash-alt"></i></a>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="pendingdisplayedColumns; sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: pendingdisplayedColumns;"></tr>
                    </table>
                  </perfect-scrollbar>
                  <div *ngIf="loadingCashOut" class="text-center">Loading...</div>
                  <div *ngIf="pendingCashData.length == 0 && !loadingCashOut" class="text-center">No record found.</div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </mat-tab>
        <!-- ***************************************************End Cash Out***************************************** -->
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-time-restore"></i>
            Account History
          </ng-template>
          <div class="addFundIn">
            <div class="addFundHeding">
              <h1>History</h1>
            </div>
            <mat-error *ngIf="errorMessage!=''" style="font-size:14px; position: relative;">{{errorMessage}} </mat-error>
            <div class="message" style="font-size:14px; position: relative;color:var(--green-dark)">{{successMessage}}</div>
            <div class="addFundHedingRight topsection-history">
              <div> 
                <small>Get Financial Report</small> <br>
              <mat-form-field class="form-control" >
                <mat-select [(ngModel)]="FinancialYearSelected" placeholder="Select Year">
                    <mat-option *ngFor="let years of financialYearList;let i = index;" [value]="years.value">{{years.value}}</mat-option> 
                </mat-select>
              </mat-form-field>
              <button mat-raised-button color="primary" class="mat-raised-button success report-button" (click)="sendFinancialReport()">Download</button>
            </div>
                <mat-form-field class="form-control" >
                  <mat-select [(ngModel)]="filtertypeVal" (selectionChange)="changeFiltertype($event.value)">
                      <mat-option *ngFor="let rec of filtertype;let i = index" [value]="rec.key" >{{rec.value}}</mat-option> 
                  </mat-select>
                </mat-form-field>
             </div>
            <div class="cardTable example-container mat-elevation-z8">
              <perfect-scrollbar class=" maxHei300" [config]="config" style="max-width: 100%;" (psYReachEnd)="accountHistory()" >
                  <table mat-table [dataSource]="accountHistoryData" >
                    <ng-container [matColumnDef]="column" *ngFor="let column of historydisplayedColumns">
                       
                        <ng-container *ngIf="column == 'trnType';else trntypecolumn">
                            <th mat-header-cell *matHeaderCellDef> 
                              Transaction Type
                            </th>
                        </ng-container>
                        <ng-template #trntypecolumn>
                            <ng-container *ngIf="column == 'particular';else historycolumn">
                                <th style="width:250px;" mat-header-cell *matHeaderCellDef> 
                                    {{column | titlecase}}
                                </th>
                            </ng-container>
                            <ng-template #historycolumn>
                                <th mat-header-cell *matHeaderCellDef> 
                                    {{column | titlecase}}
                                </th>
                            </ng-template>
                        </ng-template>
                        
                        <td mat-cell *matCellDef="let element"> 
                            {{element[column]}} 
                        </td>
                    </ng-container> 
                    
                    <tr mat-header-row *matHeaderRowDef="historydisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: historydisplayedColumns;"></tr>
                  </table>
              </perfect-scrollbar>
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="zmdi zmdi-ticket-star"></i>
            Tickets
          </ng-template>
          <div class="addFundIn">
            <div class="addFundHeding">
              <h1>Tickets</h1>
            </div>
            <div class="cardTable example-container mat-elevation-z8" >
              <perfect-scrollbar class=" maxHei300" [config]="config" style="max-width: 100%;">
                <table mat-table [dataSource]="ticketsData" class="mat-elevation-z8">
                  <ng-container matColumnDef="ticket_no">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let element" class="pR25" style="width: 50px;"> 
                      <span>{{element.ticket_no}}</span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="contest">
                    <th mat-header-cell *matHeaderCellDef>Contest</th>
                    <td mat-cell *matCellDef="let element">{{(element.description) ? element.description : '--'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="expired_on">
                    <th mat-header-cell *matHeaderCellDef>Expiry Date</th>
                    <td mat-cell *matCellDef="let element" [ngClass]="{'ticket-expired': (element.expired_text)}">{{element.expired_on}}</td>
                  </ng-container>
                  <ng-container matColumnDef="ticket_value">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let element">${{element.ticket_value.replace("$","") | number:'1.2-2' | Price}}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="ticketsdisplayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: ticketsdisplayedColumns;"></tr>
                </table>
              </perfect-scrollbar>
              <div *ngIf="loadingTicket" class="text-center">Loading...</div>
              <div *ngIf="ticketsData.length == 0 && !loadingTicket" class="text-center">No ticket found.</div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="userData && userData.payment_verified != 'Y'">
          <ng-template mat-tab-label>
            <i class="far fa-check-circle"></i>
            Verification
          </ng-template>
          <div class="addFundIn verification-form-page">
            <div class="addFundHeding">
              <h1 class="verification-title">{{isAwareVerification ? 'Verify Your Account' : 'Verification'}}</h1>
            </div>
            <app-verification *ngIf="currentTabIndex == 7" [user]="userData" [page]="cashier" [ipAddress] = "ipAddress" [darkMode] = "darkMode" [isAwareVerification] = "isAwareVerification"></app-verification>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
